import request from "@/util/http";
/**
 * 检查E-mail是否唯一
 */
export function check_email(query) {
	return request({
		url: '/upms/shop/profile/check_email',
		method: 'get',
		params: query,
	})
}

export function load_member(query) {
	return request({
		url: '/upms/shop/profile/load_member',
		method: 'get',
		params: query,
	})
}

/**
 * 检查手机是否唯一
 */
export function check_mobile(query) {
	return request({
		url: '/upms/shop/profile/check_mobile',
		method: 'get',
		params: query,
	})
}

/**
 * 编辑
 */
export function edit(query) {
	return request({
		url: '/upms/shop/profile/edit',
		method: 'get',
		params: query,
	})
}


/**
 * 更新
 */
export function update(data, params) {
	return request({
		url: '/upms/shop/profile/update',
		method: 'post',
		data: data,
		params: params,
	})
}

export function show_store_center() {
	return request({
		url: '/upms/shop/profile/show_store_center',
		method: 'get',
	})
}


// module.exports = {
// 	check_email,
// 	check_mobile,
// 	edit,
// 	update,
// 	load_member,
// 	show_store_center
// }
